<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row v-if="authPermissions.has('purchases:view')">
          <v-col lg="2" cols="12">
            <export-recieved-inventories
              v-if="authPermissions.has('purchases:create')"
            />
          </v-col>
          <v-col lg="2" cols="12">
            <report-recieved-inventories />
          </v-col>
        </v-row>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header color="primary" dark class="white--text">
              <template v-slot:actions>
                <v-icon class="icon white--text">
                  $expand
                </v-icon>
              </template>
              Transactions
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <index-recieved-inventories
                ref="indexRecievedInventoryRef"
                @edit="initEditRecInventory"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col v-if="authPermissions.has('purchases:create')" cols="12">
        <create-recieved-inventories
          @success="$refs.indexRecievedInventoryRef?.getData()"
        />
      </v-col>
    </v-row>
    <v-dialog
      v-model="editRecInventories"
      dismissable
      max-width="600px"
      eager
      class="pa-0"
    >
      <v-card>
        <v-toolbar color="primary" dark>
          <v-card-title class="pa-0">
            Edit Transaction
          </v-card-title>
        </v-toolbar>
        <edit-recieved-inventories
          ref="edit-recieved-inventory"
          @close-dialog="editRecInventories = false"
          @update="onEditRecievedInventoryUpdate"
        />
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'VRecievedInventories',
  components: {
    createRecievedInventories: () =>
      import('./../components/recieved-inventories/v2/Create'),
    indexRecievedInventories: () =>
      import('./../components/recieved-inventories/Index'),
    editRecievedInventories: () =>
      import('./../components/recieved-inventories/Edit'),
    importRecievedInventories: () =>
      import('./../components/recieved-inventories/Import'),
    exportRecievedInventories: () =>
      import('./../components/recieved-inventories/Export'),
    reportRecievedInventories: () =>
      import('./../components/recieved-inventories/Report'),
  },
  data() {
    return {
      editRecInventories: false,
    }
  },
  computed: {
    ...mapState({
      authPermissions: (state) => state.auth.userPermissions,
    }),
  },
  methods: {
    initEditRecInventory(data) {
      this.editRecInventories = true
      const { populateInputs } = this.$refs['edit-recieved-inventory']
      populateInputs(data)
    },
    onEditRecievedInventoryUpdate() {
      this.$refs.indexRecievedInventoryRef?.getData()
    },
  },
}
</script>
